exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".orientation-vertical[data-v-724b4431] {\n  display: flex;\n  flex-direction: column;\n}\n.orientation-horizontal[data-v-724b4431] {\n  display: flex;\n  flex-direction: row;\n}\n", ""]);

